
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import routeService from "@/services/route.service";

import epicService from "@/services/epic.service";
import { IEpicGamesCallbackRequestModel } from "../../models/epic.model";

@Component({
  computed: {
    ...mapGetters(["user", "token", "redirectUrl"]),
  },
})
export default class EpicGamesCallback extends Vue {
  data() {
    return {
      unwatch: null,
      useSEGARedeemer: false,
    };
  }

  created() {
    this.$data.useSEGARedeemer = this.$data.RCEnvironment.VUE_APP_USE_SEGA_REDEEMER == true;
    
    this.$data.unwatch = this.$store.watch(
      () => this.$store.getters.token,
      (token) => {
        this.$store.dispatch("updateIsLinkingEpicGamesLoading", true);
        this.$store.dispatch("updateIsLoading", true);

        if (token == null) {
          this.$store.dispatch("updateIsLinkingEpicGamesLoading", false);
          this.$store.dispatch("updateIsLoading", true);
          routeService.redirectToLogin(this);
        }
        let model : IEpicGamesCallbackRequestModel;
        if (this.$data.useSEGARedeemer) {
          if (this.$route.query.redirectUrl != undefined) {
            model = {
              State: this.$route.query.redirectUrl.toString().split("state=")[1],
              RedirectUrl: this.$route.query.redirectUrl
                .toString()
                .split("state=")[0],
              CallbackPath: "/epic-games/callback",
            } as IEpicGamesCallbackRequestModel;
          } else {
            model = {
              State: this.$route.query.state,
              CallbackPath: "/epic-games/callback",
            } as IEpicGamesCallbackRequestModel;
          }
        }
        else {
          model = {
            Code: this.$route.query.code.toString(),
          } as IEpicGamesCallbackRequestModel;
        }
        
        epicService.callbackEpicGames(this, model, token);
      }
    );
  }

  destroyed() {
    this.$data.unwatch();
  }
}
